import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  BottomNavigation,
  BottomNavigationAction,
  makeStyles,
  CssBaseline,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import PersonIcon from "@material-ui/icons/Person";
import TailFinReversed from "../../components/icons/TailFinReversed";
import BankSafe from "../../components/icons/BankSafe";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { useUserContext } from "../../components/userContext";
import { AccountRole } from "../../generated/graphql";

const useStyles = makeStyles({
  bottomNav: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgb(7,29,53)",
    padding: 40,
  },
});

const BottomBar = () => {
  const {
    currentAccount: { name: accountName, role: currentRole },
    isAstroOwner,
  } = useUserContext();
  const location = useLocation();
  const classes = useStyles();
  const [value, setValue] = React.useState(location.pathname);

  const theme = useTheme();
  const isMobileDisplay = useMediaQuery(theme.breakpoints.down("md"));
  const isAdmin = currentRole === AccountRole.Admin;
  const isOwner = currentRole === AccountRole.Owner;
  const isFinance = currentRole === AccountRole.Finance;
  const isUser = !isAdmin && !isFinance && !isOwner;
  const isAstroAccount = accountName === "Astronautics";
  const isDevices =
    (isAstroAccount && !isFinance && (isOwner || isUser || isAdmin)) ||
    (!isAstroAccount && !isFinance && !isAdmin && (isOwner || isUser));
  const isSettings = isAstroAccount || isUser || isOwner;
  const isInvoices =
    (isAstroAccount && !isUser) || (!isAstroAccount && (isUser || isOwner));
  const isFinances = isAstroOwner || (isAstroAccount && !isUser);

  useEffect(() => {
    setValue(location.pathname);
  }, [location]);

  return (
    <>
      <CssBaseline />
      {isMobileDisplay ? (
        <BottomNavigation
          className={classes.bottomNav}
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction
            component={Link}
            to="/"
            value="/"
            label="Home"
            icon={<HomeIcon />}
          />
          {isDevices && (
            <BottomNavigationAction
              component={Link}
              to="/devices"
              value="/devices"
              label="Devices"
              icon={<TailFinReversed />}
            />
          )}
          {isSettings && (
            <BottomNavigationAction
              component={Link}
              to="/settings"
              value="/settings"
              label="Settings"
              icon={<PersonIcon />}
            />
          )}
          {isFinances && (
            <BottomNavigationAction
              component={Link}
              to="/finance"
              value="/finance"
              label="Finance"
              icon={<BankSafe />}
            />
          )}
          {isInvoices && (
            <BottomNavigationAction
              component={Link}
              to="/invoices"
              value="/invoices"
              label="Invoices"
              icon={<AttachMoneyIcon />}
            />
          )}
          {isAstroOwner && (
            <BottomNavigationAction
              component={Link}
              to="/admin"
              value="/admin"
              label="Admin"
              icon={<VerifiedUserIcon />}
            />
          )}
        </BottomNavigation>
      ) : null}
    </>
  );
};

export default BottomBar;
